export const HOME = "/";
export const POOL = "/pool";
export const FARM = "/stake";
export const NFTMARKET = "/nftMarket";
export const STATS = "/stats";
export const TRENDINGNFTS = "/trendingnfts";
export const AUCTIONNFT = "/auctionnfts";
export const DETAILNFT = "/nftdetails";
export const DETAILNFTID = "/nftdetails/:contract/:tokenId";
export const NFTCATEGORIES = "/nftcategories";
export const NFTCATEGORIESID = "/nftcategories/:id";
export const NFTSPECIFICPAGE = "/specificnft";
export const NFTSPECIFICPAGEID = "/specificnft/:contract/:tokenId";
export const BUYNOW = "/buynft";
export const MyNFTS = "/mynfts";
export const VIEWNFT = "/viewnft";
export const NFTDETAIL = "nft/:id";
export const NFTDETAILVIEW = "/viewnft/:contract/:tokenId";
export const TRANSACTIONHISTORY = "/trxhistory";
export const PAYMENT = "/payment";
export const PROFILE='/profile';
